export const getSimulatorSellingPrice = (product, eventName, index) => {
    if (product?.commission_type === 'lumpsum') {
        return null;
    }
    if (eventName === `products[${index}].commission`) {
        return 0;
    }
    return product.margin;
};

export const getSimulatorMarginValue = (product, eventName, index) => {
    if (eventName === `products[${index}].margin`) {
        return 0;
    }
    if (product.commission === '') {
        return 0;
    }
    return product.commission;
};

export const getCommissionTypeLabel = (commissionType) => {
    if (commissionType === 'per_mt') {
        return 'Per Mt';
    }
    if (commissionType === 'lumpsum') {
        return 'Lumpsum';
    }
    if (commissionType === 'transaction_based') {
        return 'Transaction';
    }
    return '';
};

let productRowSeq = 0;
export const nextProductRowKey = () => `product-row-${++productRowSeq}`;

export const getProductRowKey = (product) => product.rowKey || product.type;

export const getSimulatorRowKey = (row) => row.days || row.financing_cost || row.final_price;

export const resolveSimulatorPartyIds = ({ platformRole, orgId, associatedBuyer }) => {
    let buyerId = null;
    let brokId = null;
    switch (platformRole) {
        case 'buyer':
            buyerId = orgId;
            break;
        case 'broker':
            buyerId = associatedBuyer;
            brokId = orgId;
            break;
        default:
            break;
    }
    return { buyerId, brokId };
};
